import { useSearchParams } from 'react-router-dom';
import { motion } from 'framer-motion';
import ContactForm from '../../components/contact-form/ContactForm';
import { contactHeroImage } from '../../assets/siteImages';
import { useTranslation } from '../../context/LanguageContext';
import { fadeUp, scrollViewport } from '../../motion/presets';
import '../../styles/page-hero-media.scss';
import './contact.scss';

const Contact = () => {
  const { content } = useTranslation();
  const p = content.contactPage;
  const f = content.contact.form;
  const [searchParams] = useSearchParams();
  const raw = searchParams.get('purpose') || '';
  const defaultPurpose = f.purposeOptions.some((o) => o.value === raw) ? raw : '';

  return (
    <main className="contact-page">
      <section className="contact-hero section-full" aria-labelledby="contact-hero-title">
        <div className="container page-hero-split">
          <div className="page-hero-split__copy">
            <motion.p
              className="contact-hero__eyebrow"
              initial="hidden"
              whileInView="visible"
              viewport={scrollViewport}
              variants={fadeUp}
            >
              {p.heroEyebrow}
            </motion.p>
            <motion.h1
              id="contact-hero-title"
              className="contact-hero__title"
              initial="hidden"
              whileInView="visible"
              viewport={scrollViewport}
              variants={fadeUp}
            >
              {p.heroTitle}
            </motion.h1>
            <motion.p
              className="contact-hero__lead"
              initial="hidden"
              whileInView="visible"
              viewport={scrollViewport}
              variants={fadeUp}
            >
              {p.heroLead}
            </motion.p>
            <motion.p
              className="contact-hero__tagline"
              initial="hidden"
              whileInView="visible"
              viewport={scrollViewport}
              variants={fadeUp}
            >
              {p.heroTagline}
            </motion.p>
          </div>
          <motion.figure
            className="page-hero-split__media"
            initial="hidden"
            whileInView="visible"
            viewport={scrollViewport}
            variants={fadeUp}
          >
            <img
              className="page-hero-split__photo"
              src={contactHeroImage}
              alt={p.heroPhotoAlt}
              loading="eager"
              decoding="async"
            />
          </motion.figure>
        </div>
      </section>

      <section className="contact-body section-full" aria-labelledby="contact-form-title">
        <div className="container contact-body__inner">
          <div className="contact-body__grid">
            <div id="contact-form-anchor">
              <motion.h2
                id="contact-form-title"
                className="contact-body__title"
                initial="hidden"
                whileInView="visible"
                viewport={scrollViewport}
                variants={fadeUp}
              >
                {p.formTitle}
              </motion.h2>
              <motion.p
                className="contact-body__intro"
                initial="hidden"
                whileInView="visible"
                viewport={scrollViewport}
                variants={fadeUp}
              >
                {p.formIntroBefore}{' '}
                <a href={`mailto:${content.common.mail}`}>{content.common.mail}</a>.
              </motion.p>
              <ContactForm key={defaultPurpose || 'default'} defaultPurpose={defaultPurpose} />
            </div>

            <motion.aside
              className="contact-aside"
              initial="hidden"
              whileInView="visible"
              viewport={scrollViewport}
              variants={fadeUp}
            >
              <h3 className="contact-aside__title">{p.asideTitle}</h3>
              <ul className="contact-aside__list">
                <li>
                  <strong>{p.asideWhatsappStrong}</strong>
                  {p.asideWhatsapp}
                </li>
                <li>
                  <strong>{p.asideEmailStrong}</strong> <a href={`mailto:${content.common.mail}`}>{content.common.mail}</a>{' '}
                  {p.asideEmailAfter}
                </li>
                <li>
                  <strong>{p.asideAppStrong}</strong>
                  {p.asideApp}
                </li>
              </ul>
              <p className="contact-aside__foot">{p.asideFoot}</p>
            </motion.aside>
          </div>
        </div>
      </section>
    </main>
  );
};

export default Contact;
